<div class="modal-header">
	<h2>
		<svg width="38px" height="37px" viewBox="0 0 38 38">
			<g id="Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
				stroke-linejoin="round">
				<g stroke-width="1.5">
					<path class="svg-stroke"
						d="M18,18 C20.7417273,18 22.9090909,15.9962727 22.9090909,13.0909091 L22.9090909,10.6363636 C22.9090909,7.731 20.7417273,5.72727273 18,5.72727273 C15.2582727,5.72727273 13.0909091,7.731 13.0909091,10.6363636 L13.0909091,13.0909091 C13.0909091,15.9962727 15.2582727,18 18,18 Z"
						id="Stroke-1"></path>
					<path class="svg-stroke" class="svg-stroke"
						d="M27.8181818,30.2727273 L27.8181818,26.1818182 C27.8181818,22.5155455 21.3021818,20.4545455 18,20.4545455 C14.6978182,20.4545455 8.18181818,22.5155455 8.18181818,26.1818182 L8.18181818,30.2727273"
						id="Stroke-3"></path>
					<path class="svg-stroke"
						d="M36,18 C36,27.9409091 27.9409091,36 18,36 C8.05909091,36 0,27.9409091 0,18 C0,8.05909091 8.05909091,0 18,0 C27.9409091,0 36,8.05909091 36,18 Z"
						id="Stroke-5"></path>
				</g>
			</g>
		</svg>

		<ng-container i18n="@@clients.add_new_client">Add New Client</ng-container>
	</h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square"
				d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
		</svg>
	</button>
</div>
<div class="modal-body">
	<form [formGroup]="clientForm" (ngSubmit)="clientForm.valid && submit()" class="new-client flex-container" #newClientForm="ngForm">

		<fieldset>
			<label i18n="@@clients.business_name">Business Name</label>
			<input type="text" name="company" formControlName="business_name" (blur)="onChangeField()"/>
		</fieldset>

		<fieldset class="half">
			<label i18n="@@clients.tax_reg_number">VAT registration Number</label>
			<input type="text" name="tax-registration" formControlName="tax_reg_number" (blur)="onChangeField()"/>
		</fieldset>

		<fieldset class="half">
			<label i18n="@@clients.cr_number">CR Number</label>
			<input type="text" name="tax-registration" formControlName="buyer_cr_number" />
		</fieldset>

		<fieldset class="half" [ngClass]="{ 'has-error': (submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name')?.errors }">
			<label for="name" i18n="@@clients.first_name">First Name<span class="req-star">*</span></label>
			<input type="text" id="first_name" name="first_name" formControlName="first_name" (blur)="onChangeField()"/>
			<span class="field-error" i18n="@@clients.validation.first_name" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.required">First name is required</span>
			<span class="field-error" i18n="@@validation.errors.enter_valid_first_name" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.pattern">Please enter valid first name</span>
			<span class="field-error" i18n="@@validation.errors.first_name_less_than_100_character" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.maxlength">First name must be less than 100 characters</span>
			<span class="field-error" i18n="@@validation.errors.first_name_greater_than_2_character" *ngIf="(submitted || clientForm.get('first_name').dirty) && clientForm.get('first_name').errors?.minlength">First name must be greater than 2 characters</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{ 'has-error': (submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name')?.errors }">
			<label for="name" i18n="@@clients.last_name">Last Name</label>
			<input type="text" id="last_name" name="last_name" formControlName="last_name" (blur)="onChangeField()" />
			<!-- <span class="field-error" i18n="@@clients.validation.last_name">Last name is required</span> -->
			<span class="field-error" i18n="@@validation.errors.enter_valid_last_name" *ngIf="(submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name').errors?.pattern">Please enter valid last name </span>
			<span class="field-error" i18n="@@validation.errors.last_name_less_than_100_character" *ngIf="(submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name').errors?.maxlength">Last name must be less than 100 characters</span>
			<span class="field-error" i18n="@@validation.errors.last_name_greater_than_2_character" *ngIf="(submitted || clientForm.get('last_name').dirty) && clientForm.get('last_name').errors?.minlength">Last name must be greater than 2 characters</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': clientForm.get('country_id').errors?.serverError || ((submitted || clientForm.get('country_id').dirty) && clientForm.get('country_id').errors) }">
			<label for="country">
				<ng-container i18n="@@clients.country">Country</ng-container><span class="req-star">*</span>
			</label>
			<select
				app-select2
				[options]="{
					ajax: {url: countryListApi},
					idColumn: 'id',
					textColumn: 'name',
					dropdownParent: 'form.new-client'
				}"
				(itemSelected)="onCountryChange($event)"
			 	i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name"
			 	name="country_id"
			 	formControlName="country_id"
		 	><option></option></select>
			<span class="field-error" i18n="@@error.required" *ngIf="(submitted || clientForm.get('country_id').dirty) && clientForm.get('country_id').errors?.required">Country is required</span>
			<span class="field-error">{{clientForm.get('country_id').errors?.serverError}}</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': clientForm.get('phone').errors?.serverError || ((submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors) }">
			<label for="phone">
				<ng-container i18n="@@clients.phone">Phone</ng-container><span class="req-star">*</span>
			</label>
			<div class="tel-input-group">
				<input type="text" formControlName="dial_code" id="countryCode" name="country_code" readonly class="dial-code">
				<input type="number" formControlName="phone" id="phone" i18n-placeholder="@@clients.phone" placeholder="Phone" name="phone" maxlength="10" class="phone-with-code" (blur)="onChangeField()" appPreventScroll >
				<span class="field-error" i18n="@@error.required" *ngIf="(submitted || clientForm.get('phone').dirty) && clientForm.get('phone').errors?.required">Phone is required</span>
				<span class="field-error">{{clientForm.get('phone').errors?.serverError}}</span>
			</div>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': clientForm.get('email').errors?.serverError || ((submitted || clientForm.get('email').dirty) && clientForm.get('email').errors) }">
			<label for="email" i18n="@@clients.email">E-mail</label>
			<input type="text" id="email" name="email" formControlName="email" />
			<span class="field-error" i18n="@@error.valid_email" *ngIf="(submitted || clientForm.get('email').dirty) && clientForm.get('email').errors?.email">Please enter valid email address </span>
			<span class="field-error">{{clientForm.get('email').errors?.serverError}}</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': submitted && clientForm.get('website').errors}">
			<label for="website" i18n="@@clients.website">Website</label>
			<input type="text" id="website" name="website" formControlName="website" />
			<span class="field-error" i18n="@@clients.validation.website"> Incorrect URL </span>
		</fieldset>

		<fieldset class="half">
			<div class="field_cont custom-date-wrapper">
				<label for="dob" i18n="@@clients.date_of_birth">Date of Birth</label>
				<input type="date" placeholder="Select date" id="date_of_birth" name="date_of_birth" formControlName="date_of_birth" class="date-input startDate"/>
				<!-- <svg class="custom-date-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg> -->
			</div>
		</fieldset>

		<fieldset class="half">
			<label for="address" i18n="@@clients.address">Address</label>
			<input type="text" id="address" name="address" formControlName="address" />
		</fieldset>
	</form>
</div>
<div class="modal-footer">
	<button type="button" (click)="submitted=true; newClientForm.ngSubmit.emit()" class="tu-btn pink"
		i18n="@@clients.save">Save</button>
</div>
